import { HttpMethod, initFetch } from "../../utils/fetcher";
import { requetesToAdapted } from "../../adapter/requeteAdapter";
import { requeteLotsToAdapted } from "../../adapter/requeteLotAdapter";
import { locationsToAdapted } from "../../adapter/locationAdapter";
import { quittancesToAdapted } from "../../adapter/quittanceAdapter";
import { rendusToAdapted } from "../../adapter/renduAdapter";

export const MERGE_SUCCESS_DEMANDES_LOCATAIRE = "MERGE_SUCCESS_DEMANDES_LOCATAIRE";

// Charge toutes les demandes d'un locataire (société active, sans filtre d'année)
// et remplace ses données dans les slices requetes, requetesLots, locations,
// quittances et renduAs. La réponse DOIT être exhaustive pour ce locataire :
// les reducers suppriment tout ce qui lui appartient avant d'ajouter la réponse.
// Résout avec les demandes du locataire.
// force : ignore le cache (rechargement au retour sur l'onglet de la demande).
// ATTENTION : la réponse ne contient aucun règlement. Pour l'exercice chargé,
// `reglements?year=` ne renvoie, hors période, que les règlements non reddités :
// après la fusion, une quittance d'un exercice passé n'a dans le store que ses
// règlements non reddités, et un reste dû calculé côté front est faux.
// Ces quittances sont listées dans `state.quittances.horsExercice` (cf. quittanceReducer).
// Tout écran qui croise quittances et règlements doit en tenir compte
// (seul l'onglet Encaissement locataires le fait aujourd'hui).
export function loadDemandesLocataire(idLocataire, force = false) {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      const { demandesLocataires, requetes } = getState();
      if (!force && demandesLocataires.data.includes(idLocataire)) {
        resolve(
          requetes.data.filter((item) => item.requete_locataire?.locataire_id === idLocataire)
        );
        return;
      }

      const { url, params } = initFetch(`tenant/${idLocataire}/rentals`, HttpMethod.GET);
      fetch(url, params)
        .then((res) => {
          if (res.ok) {
            return res.json();
          } else {
            throw new Error("500");
          }
        })
        .then((res) => {
          const payload = {
            locataireId: idLocataire,
            requetes: requetesToAdapted(res.requete) || [],
            requetesLots: requeteLotsToAdapted(res.requete_lot) || [],
            locations: locationsToAdapted(res.location) || [],
            quittances: quittancesToAdapted(res.quittance) || [],
            renduAs: rendusToAdapted(res.rendu_a) || [],
          };
          dispatch({ type: MERGE_SUCCESS_DEMANDES_LOCATAIRE, payload });
          resolve(payload.requetes);
        })
        .catch((err) => reject(err));
    });
  };
}
